import { render, staticRenderFns } from "./FarmResources.vue?vue&type=template&id=2f76f305&"
import script from "./FarmResources.vue?vue&type=script&lang=js&"
export * from "./FarmResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports